<template>
  <v-card
    color="grey lighten-4"
    light
  >
    <v-card-text>
      <content-section
        title="Who am I?"
      >
        I am a young programmer with 5 years of experience
        in software development. Both in the field of web
        development and video game development. Lately I am learning a lot in the area of shading programming,
        I really like to vary and continue to accress my skills.
      </content-section>
      <!-- <content-section
        v-if="prouds"
        title="What am I proud of?"
      >
        <v-layout
          v-for="(proud, i) in prouds"
          :key="i"
        >
          <v-flex
            md1
            xs3
          >
            <v-icon right>
              {{ proud.icon }}
            </v-icon>
          </v-flex>
          <v-flex
            md11
            xs9
          >
            <p>
              <strong>{{ proud.text }}</strong><br>
              <small>{{ proud.source }}</small>
            </p>
          </v-flex>
        </v-layout>
      </content-section> -->
      <content-section
        v-if="educations"
        title="Education"
      >
        <v-layout
          v-for="(education, i) in educations"
          :key="i"
        >
          <v-flex md4>
            {{ education.from }} - {{ education.to }}
          </v-flex>
          <v-flex md8>
            <strong v-if="education.title">{{ education.title }}</strong>
            <div v-if="education.location">
              <i>{{ education.location }}</i>
            </div>
            <div v-if="education.description">
              {{ education.description }}
            </div>
          </v-flex>
        </v-layout>
      </content-section>
      <content-section
        v-if="skills"
        id="to-timeline"
        title="Skills"
      >
        <template slot="actions">
          (% are relative not absolute)
        </template>
        <v-layout
          wrap
          style="display: flex; flex-direction: row; text-align-last: center;
;"
        >
          <template
            v-for="(skill, i) in skills"
          >
            <v-flex
              v-if="skill.divider"
              :key="i"
              md12
              xs12
              mb-4
            >
              <h3 class="mr-1">
                {{ skill.title }}
              </h3>
            </v-flex>
            <v-flex
              v-else
              :key="i"
              md6
              xs12
            >
              <div
                class="mr-2 ml-2"
              >
                <div class="align-center">
                  <v-icon
                    small
                  >
                    {{ skill.icon }}
                  </v-icon>
                  {{ skill.title }}
                </div>
                <v-progress-linear
                  class="progress"
                  color="secondary"
                  height="3"
                  :value="skill.value"
                />
              </div>
            </v-flex>
          </template>
        </v-layout>
      </content-section>
    </v-card-text>
  </v-card>
</template>

<script>
import ContentSection from '@/views/dark-template/content/Section'
export default {
  name      : 'MainContent',
  components: { ContentSection },
  data      : () => ({
    prouds    : [],
    educations: [
      {
        from       : '2017',
        to         : '2019',
        title      : 'Game programmer',
        location   : 'Event Horizon School, Turin, Italy',
        description: 'Developed skill on game developing',
      },
    ],
    skills: [
      { divider: true, title: 'Game Development' },
      {
        title: 'C#',
        icon : '',
        value: 85,
      },
      {
        title: 'C/C++',
        icon : '',
        value: 70,
      },
      {
        title: 'Unity',
        icon : 'mdi-unity',
        value: 80,
      },
      {
        title: 'Shader-Graph',
        icon : 'mdi-waves',
        value: 80,
      },
      {
        title: 'CG',
        icon : 'mdi-waves',
        value: 80,
      },
      {
        title: 'UnrealEngine4',
        icon : 'mdi-unreal',
        value: 60,
      },
      { divider: true, title: 'Web Field' },
      {
        title: 'NodeJs',
        icon : 'mdi-nodejs',
        value: 80,
      },
      {
        title: 'Python',
        icon : 'mdi-language-python',
        value: 70,
      },

      {
        title: 'Angular',
        icon : 'mdi-angularjs',
        value: 75,
      },
      {
        title: 'Java',
        icon : 'mdi-language-java',
        value: 70,
      },
      {
        title: 'PHP',
        icon : 'mdi-language-php',
        value: 60,
      },
      {
        title: 'Vue.js Framework',
        icon : 'mdi-vuejs',
        value: 70,
      },

      { divider: true, title: 'IT Field' },
      {
        title: 'Ubuntu Server',
        icon : 'mdi-ubuntu',
        value: 75,
      },
      {
        title: 'CentOS Server',
        icon : 'mdi-linux',
        value: 75,
      },
      {
        title: 'Continuous Integration / Continuous Delivery',
        icon : 'mdi-truck-fast',
        value: 50,
      },
      {
        title: 'Git',
        icon : 'mdi-git',
        value: 85,
      },
      { divider: true },
    ],
  }),
}
</script>

<style scoped>
.title {
  border-bottom: 2px #bfbfbf solid;
  line-height: 1.5 !important;
}
.progress {
  margin-top: 0.1rem;
}
</style>
